import { ITimestampResponse } from '@/types/common';
import { Moment } from 'moment';
import { IArticle } from '../article';
import { IOffer } from '../offer';
import { Status } from '@/utils';

export enum ChatFukumaruSourceType {
  ARTICLE = 'article',
  OFFER = 'offer',
}

export const chatFukumaruSourceTypeJP: Record<ChatFukumaruSourceType, string> = {
  [ChatFukumaruSourceType.ARTICLE]: '記事',
  [ChatFukumaruSourceType.OFFER]: 'オファー',
};

export interface IChatFukumaru extends ITimestampResponse {
  title: string;
  message: string;
  status: Status;
  startAt: Moment;
  publicAt: Moment | null;
  image: any;
  sourceType?: ChatFukumaruSourceType;
  sourceId?: number;
  article?: IArticle;
  offer?: IOffer;
  id: number;
  url?: string;
}

export interface IGetListChatFukumaruResponse extends IChatFukumaru {}

export interface IGetDetailChatFukumaruResponse extends IChatFukumaru {}

